module.exports = __webpack_public_path__ + "static/media/after_wanko.9c58f144.jpeg";